(() => {
  const activeClass = "-active";
  const navs = document.querySelectorAll(".c_sidemenu_nav");

  if (!navs.length) {
    return;
  }

  const getHeaderHeight = () => {
    const header = document.querySelector("#header, .header, .js-header");
    return header ? header.offsetHeight : 0;
  };

  const getScrollPaddingTop = () => {
    const value = getComputedStyle(document.documentElement).scrollPaddingTop;
    return Number.parseFloat(value) || 0;
  };

  const getScrollOffset = () => getScrollPaddingTop() || getHeaderHeight();

  const getTarget = (link) => {
    const hash = link.hash;

    if (!hash || hash === "#") {
      return null;
    }

    return document.getElementById(decodeURIComponent(hash.slice(1)));
  };

  const clearActive = (links) => {
    for (const link of links) {
      link.classList.remove(activeClass);
      link.closest("li")?.classList.remove(activeClass);
    }
  };

  const activateLink = (link, links) => {
    if (!link) {
      return;
    }

    clearActive(links);

    link.classList.add(activeClass);
    link.closest("li")?.classList.add(activeClass);

    const parentItem = link
      .closest(".c_sidemenu_nav_sublist")
      ?.closest(".c_sidemenu_nav_item");
    const parentLink = parentItem?.querySelector(":scope > .c_sidemenu_nav_link");

    parentItem?.classList.add(activeClass);
    parentLink?.classList.add(activeClass);
  };

  const initSideMenuScrollSpy = (nav) => {
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links
      .map((link) => ({
        link,
        target: getTarget(link),
      }))
      .filter((item) => item.target);

    if (!targets.length) {
      return;
    }

    const updateActive = () => {
      const viewportTop = getScrollOffset();
      const viewportBottom = window.innerHeight;
      const visibleTargets = targets
        .map((item) => ({
          ...item,
          rect: item.target.getBoundingClientRect(),
        }))
        .filter(({ rect }) => rect.bottom > viewportTop && rect.top < viewportBottom);

      if (visibleTargets.length) {
        const enteringTargets = visibleTargets.filter(
          ({ rect }) => rect.top >= viewportTop,
        );
        const nextTarget = (
          enteringTargets.length ? enteringTargets : visibleTargets
        ).sort((a, b) => {
          if (enteringTargets.length) {
            return a.rect.top - b.rect.top;
          }

          return b.rect.top - a.rect.top;
        })[0];

        activateLink(nextTarget.link, links);
        return;
      }

      const passedTargets = targets
        .map((item) => ({
          ...item,
          top: item.target.getBoundingClientRect().top,
        }))
        .filter(({ top }) => top <= viewportTop);
      const latestTarget = passedTargets[passedTargets.length - 1];

      activateLink(latestTarget?.link || targets[0].link, links);
    };

    let ticking = false;
    const requestUpdate = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(() => {
        updateActive();
        ticking = false;
      });
    };

    updateActive();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    window.addEventListener("hashchange", requestUpdate);
  };

  for (const nav of navs) {
    initSideMenuScrollSpy(nav);
  }
})();
